import http from '@/utils/http';
export const secGroupTypeAdd = (data) => {
  return http.post({
    url: '/api/secGroupType/add',
    json: data,
  });
};
export const secGroupTypeEdit = (data) => {
  return http.post({
    url: '/api/secGroupType/edit',
    json: data,
  });
};
export const secGroupTypeList = (data) => {
  return http.get({
    url: '/api/secGroupType/list',
    data: data,
  });
};
export const secGroupTypeDel = (data) => {
  return http.post({
    url: '/api/secGroupType/delete',
    json: data,
  });
};
export const transforGroupType = (data) => {
  return http.post({
    url: '/api/secGroupType/transferGroupType',
    json: data,
  });
};
export const listSecurityGroup = (data) => {
  return http.get({
    url: '/api/securityCenter/listSecurityGroup',
    data: data,
  });
};
export const batchSwitchSecurity = (data) => {
  return http.post({
    url: '/api/independ/batchSwitchSecurity',
    json: data,
  });
};
export const batchSwitchExeSwitch = (data) => {
  return http.post({
    url: '/api/independ/batchSwitchExeSwitch',
    json: data,
  });
};
